var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 10.0001H18.3333M1.66663 10.0001C1.66663 14.6025 5.39759 18.3334 9.99996 18.3334M1.66663 10.0001C1.66663 5.39771 5.39759 1.66675 9.99996 1.66675M18.3333 10.0001C18.3333 14.6025 14.6023 18.3334 9.99996 18.3334M18.3333 10.0001C18.3333 5.39771 14.6023 1.66675 9.99996 1.66675M9.99996 1.66675C12.0844 3.94871 13.2689 6.91011 13.3333 10.0001C13.2689 13.0901 12.0844 16.0515 9.99996 18.3334M9.99996 1.66675C7.91556 3.94871 6.731 6.91011 6.66663 10.0001C6.731 13.0901 7.91556 16.0515 9.99996 18.3334",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternational);
export default __webpack_public_path__ + "static/media/international.6278138dbceefaa9e4624284c04f1283.svg";
export { ForwardRef as ReactComponent };